import getCookies from '@/config/get-cookies'

export const FEATURE_FLAGS_COOKIE = 'hb_feature_flags'
export const PRICE_DROP_BANNER_FLAG = 'ION-2368'

export const isSSOEnabled = (country) => {
  const GOOGLE_SSO_COUNTRY = process.env[`VUE_APP_GOOGLE_SSO_${country}`]
  return GOOGLE_SSO_COUNTRY === 'true' || getCookies.get('test_sso_cookie') === 'true'
}

// Check for feature flags under the hb_feature_flags cookie.
export const hasFeatureFlag = (flag) => {
  const flags = getCookies.get(FEATURE_FLAGS_COOKIE)
  if (!flags) return false
  try {
    return decodeURIComponent(flags).split(',').map(featureFlag => featureFlag.trim()).includes(flag)
  } catch (error) {
    return false
  }
}

export const isPriceDropBannerEnabled = () => hasFeatureFlag(PRICE_DROP_BANNER_FLAG)

export default {
  isSSOEnabled,
  hasFeatureFlag,
  isPriceDropBannerEnabled
}
